import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

import { buttonRegister, noAccount } from "../../_constants";
import { useAppDispatch } from "store/store";
import { resetRegisterForm } from "store/slicer/registerFormSlice";

export const GoToRegisterBtn = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const goToRegisterPage = () => {
    dispatch(resetRegisterForm());
    navigate("/register");
  };

  return (
    <div className="container-btn">
      <p className="light-text">{noAccount}</p>{" "}
      <Button
        className="padd-0"
        label={buttonRegister}
        link
        onClick={goToRegisterPage}
      />
    </div>
  );
};
